import { formatISO } from 'date-fns';

export const formatDate = (date: Date) => (date ? formatISO(date, { representation: 'date' }) : undefined);
